import {
	ModuleRegistry,
	provideGlobalGridOptions,
	themeQuartz,
} from "ag-grid-community"
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise"

const key = import.meta.env.VITE_AG_GRID_LICENSE_KEY
if (key) {
	LicenseManager.setLicenseKey(key)
} else if (import.meta.env.DEV) {
	// eslint-disable-next-line no-console
	console.warn(
		"[ag-grid] No VITE_AG_GRID_LICENSE_KEY set — enterprise features will show a watermark.",
	)
}

ModuleRegistry.registerModules([AllEnterpriseModule])

/**
 * The one table look of the admin (specs/admin-design-system/README.md,
 * "Tables"). Every value reads the admin's CSS variables, so the grids follow
 * light and dark without a class switch.
 */
export const adminGridTheme = themeQuartz.withParams({
	fontFamily: "var(--font-sans)",
	fontSize: 13,
	headerFontSize: 12,
	headerFontWeight: 500,
	rowHeight: 36,
	headerHeight: 34,
	spacing: 6,
	iconSize: 14,
	backgroundColor: "var(--card)",
	foregroundColor: "var(--foreground)",
	headerBackgroundColor: "var(--card)",
	headerTextColor: "var(--meta)",
	borderColor: "var(--border)",
	wrapperBorderRadius: 8,
	columnBorder: false,
	headerColumnBorder: false,
	rowBorder: true,
	rowHoverColor: "var(--row-hover)",
	selectedRowBackgroundColor:
		"color-mix(in srgb, var(--primary) 14%, transparent)",
	accentColor: "var(--marker)",
	browserColorScheme: "inherit",
})

// Header menu and filter buttons appear on hover only (AG Grid shows them permanently by default).
provideGlobalGridOptions({ theme: adminGridTheme, suppressMenuHide: false })
